import React from 'react';

import LeftMenuSection from '../custom/-APP_TARGET/content/LeftMenuSection';

function MyPlaylistsMenuSection() {
  return <LeftMenuSection />
}

export default MyPlaylistsMenuSection;
